import { ButtonHTMLAttributes, HTMLAttributeAnchorTarget, PropsWithChildren } from "react";
import { Link, To } from "react-router-dom";
import { twMerge } from "tailwind-merge";

// type InheritedProps =  React.ComponentPropsWithoutRef<"button"> | LinkProps

export type BaseButtonProps = PropsWithChildren<{
  to?: To;
  href?: string;
  onClick?: (e: React.MouseEvent<HTMLElement>) => void;
  disabled?: boolean;
  className?: string;
  target?: HTMLAttributeAnchorTarget;
  type?: ButtonHTMLAttributes<HTMLButtonElement>["type"];
}>;

export const BaseButton = (props: BaseButtonProps) => {
  const { to, href, disabled, ...restProps } = props;

  const blockClassName = twMerge(
    "block focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-lac-leman focus-visible:ring-offset-2 focus-visible:ring-offset-white",
    restProps.className,
  );

  if (to || href) {
    if (disabled) {
      const { onClick, ...divProps } = restProps;
      return <div {...divProps} />;
    }

    if (to) return <Link {...restProps} className={blockClassName} to={to} />;

    return (
      <a target="_blank" rel="noreferrer" {...restProps} className={blockClassName} href={href}>
        {restProps.children}
      </a>
    );
  }

  return <button {...restProps} className={blockClassName} disabled={disabled} />;
};
